import { CSSProperties, FC } from 'react';
import { ErrorMessage, Field, FieldInputProps } from 'formik';
import { TextInput } from '@mantine/core';

interface FieldTextProps {
    name: string;
    title: string;
    placeholder?: string;
    required?: boolean;
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    style?: CSSProperties;
    disabled?: boolean;
}

const FieldText: FC<FieldTextProps> = ({
    name,
    title,
    placeholder,
    required,
    size,
    style,
    disabled
}: FieldTextProps) => {
    return (
        <>
            <Field name={name}>
                {({ field }: { field: FieldInputProps<string> }) => (
                    <TextInput
                        label={title + (required ? ' *' : '')}
                        placeholder={placeholder || title}
                        value={field.value || ''}
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                        id={field.name}
                        style={style}
                        size={size || 'md'}
                        disabled={disabled}
                    />
                )}
            </Field>
            <ErrorMessage name={name} component="span" className="required" />
        </>
    );
};

export default FieldText;
